import { makeAutoObservable } from "mobx";

import { SearchObject } from "app/common/Model/SearchObject";
import { toast } from "react-toastify";
import { checkSearchObject } from "app/common/LocalFunction";
import { PageResponse } from "app/common/Model/Shared";
import {
  reportRevenueAllocation,
  reportSalesAllocation,
  updateListStaffRevenue,
  exportExcelInvoiceItemRevenueAllocationReport,
} from "app/services/ReportService";
import { ALLOCATION_UPON_PAYMENT } from "app/common/LocalConst";
import { lockVoucherItemsBySearchReport, updateLockListVoucherItem, exportVoucherReportItem } from "app/services/VoucherItemService";

const DEFAULT_VALUES = {
  fromDate: new Date(),
  toDate: new Date(),
};
export default class ReconcileAllocatedRevenueStore {
  searchReconcileAllocatedRevenue = {
    ...new SearchObject(),
    ...DEFAULT_VALUES,
  };
  searchVouchItemListUpdateLock = {
    ...new SearchObject(),
    ...DEFAULT_VALUES,
  };

  pageReconcileAllocatedRevenue = new PageResponse();
  openUpdateLockReconcile = false;
  openUpdateListReconcile = false;
  listSelectedReconcile = [];
  openConfirmUpdateLock = false;
  openVouchItemListUpdateLockPopup = false;

  constructor() {
    makeAutoObservable(this);
  }

  pagingReconcileAllocatedRevenue = async () => {
    let api = reportRevenueAllocation;
    let { departmentId, staffId, positionId,sourceIds, ...ortherData } =
      this.searchReconcileAllocatedRevenue;
    if (staffId) {
      ortherData.staffId = staffId?.id;
    }
    if (departmentId) {
      ortherData.departmentId = departmentId?.id;
    }
    if (positionId) {
      ortherData.positionId = positionId?.id;
    }
     if (Array.isArray(sourceIds)) {
      ortherData.sourceIds = sourceIds.map((x) => x.id);
    }
    if (ortherData?.revenueType === ALLOCATION_UPON_PAYMENT) {
      api = reportSalesAllocation;
    }
    return await api({ ...ortherData })
      .then(({ data }) => {
        this.pageReconcileAllocatedRevenue = data;
      })
      .catch((error) => {
        console.error(error);
        toast.error("Lấy dữ liệu có lỗi");
      });
  };

  handleExportExcel = async () => {
    let api = exportExcelInvoiceItemRevenueAllocationReport;
    let filename = "BAO_CAO_DOANH_THU_PHAN_BO.xlsx";
    
    let { departmentId, staffId, positionId, sourceIds, ...ortherData } =
      this.searchReconcileAllocatedRevenue;
      
    if (staffId) {
      ortherData.staffId = staffId?.id;
    }
    if (departmentId) {
      ortherData.departmentId = departmentId?.id;
    }
    if (positionId) {
      ortherData.positionId = positionId?.id;
    }
    if (Array.isArray(sourceIds)) {
      ortherData.sourceIds = sourceIds.map((x) => x.id);
    }
    
    if (ortherData?.revenueType === ALLOCATION_UPON_PAYMENT) {
      api = exportVoucherReportItem;
      filename = "BAO_CAO_DOANH_SO_PHAN_BO.xlsx";
    }

    try {
      const response = await api(ortherData);
      if (response.status === 200) {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", filename);
        document.body.appendChild(link);
        link.click();
        link.parentNode.removeChild(link);
      }
    } catch (error) {
      console.error("Error export excel report:", error);
      toast.error("Có lỗi xảy ra khi xuất Excel");
    }
  };

  handleOpenUpdateReconcile = (row) => {
    this.listSelectedReconcile = [row];
    this.openUpdateListReconcile = true;
  };

  handleOpenUpdateListReconcile = () => {
    this.openUpdateListReconcile = true;
  };

  handleCloseUpdateListReconcile = () => {
    this.openUpdateListReconcile = false;
  };

  setListSelectedReconcile = (list) => {
    this.listSelectedReconcile = list;
  };

  handleOpenUpdateLockReconcile = (row) => {
    this.listSelectedReconcile = [row];
    this.openUpdateLockReconcile = true;
  };

  handleCloseUpdateLockReconcile = () => {
    this.openUpdateLockReconcile = false;
  };

  handleUpdateListStaffRevenue = (values) => {
    try {
      const { data } = updateListStaffRevenue(values?.items);
      toast.success("Cập nhật thông tin thành công!");
      this.listSelectedReconcile = [];

      this.handleCloseUpdateListReconcile();
      this.handleCloseUpdateLockReconcile();

      setTimeout(() => {
        this.pagingReconcileAllocatedRevenue();
      }, 300);
    } catch (error) {
      toast.error("Cập nhật thông tin có lỗi");
    }
  };

  handleUpdateLockVoucherItem = async (statusLock) => {
    try {
      const list = this.listSelectedReconcile;

      if (!Array.isArray(list) || list.length === 0) {
        return toast.warning("Không có đối soát nào được chọn!");
      }

      const ids = list.map((el) => el?.id).filter(Boolean);

      // Xác định trạng thái khóa
      const locked =
        statusLock !== undefined
          ? statusLock
          : !list[0]?.locked;

      const obj = { ids, locked };

      // Call API
      const { data } = await updateLockListVoucherItem(obj);

      toast.success("Đã cập nhật khóa đối soát!");

      if (statusLock !== undefined) {
        this.handleCloseUpdateListReconcile();
      } else {
        this.handleCloseUpdateLockReconcile();
        this.handleCloseConfirmUpdateLock();
      }
      // Làm mới danh sách sau 300ms
      setTimeout(this.pagingReconcileAllocatedRevenue, 300);
    } catch (error) {
      console.error(error);
      toast.error("Cập nhật thông tin có lỗi");
    }
  };


  // call search tìm kiếm theo báo cáo -> thực hiện khóa
  handleUpdateVouchItemListUpdateLock = async (obj) => {
    try {
      // Convert các field object sang id nếu có
      const payload = { ...obj };
      if (payload.staffId) payload.staffId = payload.staffId.id;
      if (payload.departmentId) payload.departmentId = payload.departmentId.id;
      if (payload.positionId) payload.positionId = payload.positionId.id;

      // Gọi API
      const { data } = await lockVoucherItemsBySearchReport(payload);

      if (data > 0) {
        toast.success("Đã cập nhật khóa đối soát!");
        this.handleCloseVouchItemListUpdateLock();

        setTimeout(() => {
          this.pagingReconcileAllocatedRevenue();
        }, 300);
      } else {
        toast.error("Không có đối soát nào được cập nhật.");
      }
    } catch (error) {
      console.error(error);
      toast.error("Cập nhật thông tin có lỗi");
    }
  };



  handleChangeFormSearch = (searchReconcileAllocatedRevenue) => {
    this.searchReconcileAllocatedRevenue = checkSearchObject(
      this.searchReconcileAllocatedRevenue,
      searchReconcileAllocatedRevenue
    );
    this.pagingReconcileAllocatedRevenue();
  };

  handleOpenConfirmUpdateLock = () => {
    this.openConfirmUpdateLock = true;
  };

  handleCloseConfirmUpdateLock = () => {
    this.openConfirmUpdateLock = false;
  };

  handleOpenVouchItemListUpdateLock = () => {
    this.openVouchItemListUpdateLockPopup = true;
  };

  handleCloseVouchItemListUpdateLock = () => {
    this.openVouchItemListUpdateLockPopup = false;
  };

  resetStore = () => {
    this.searchReconcileAllocatedRevenue = {
      ...new SearchObject(),
      ...DEFAULT_VALUES,
    };
    this.pageReconcileAllocatedRevenue = new PageResponse();
  };
}
